import { IForm } from '@/components/types'

export const modalConfig: IForm = {
  formItems: [
    {
      field: 'title',
      type: 'input',
      label: '标题',
      placeholder: '请输入标题',
      rules: { required: true, message: '标题是必传的', trigger: 'blur' }
    },
    {
      field: 'videoUrl',
      type: 'input',
      label: '录播链接',
      placeholder: '请输入录播链接',
      rules: {
        required: true,
        message: '录播链接是必传的',
        trigger: 'blur'
      }
    },
    {
      field: 'fluentUrl',
      type: 'input',
      label: '流畅版链接',
      placeholder: '请输入流畅版链接'
    },
    {
      field: 'cloudDiskUrl',
      type: 'input',
      label: '云盘版链接',
      placeholder: '请输入云盘版链接'
    },
    {
      field: 'mp3Url',
      type: 'input',
      label: 'mp3链接',
      placeholder: '请输入mp3链接'
    },
    {
      field: 'teacherId',
      type: 'select',
      label: '老师',
      placeholder: '请选择老师',
      rules: {
        required: true,
        message: '老师是必选的',
        trigger: 'blur'
      }
    },
    {
      field: 'courseId',
      type: 'select',
      label: '课程',
      placeholder: '请选择课程',
      rules: {
        required: true,
        message: '课程是必选的',
        trigger: 'blur'
      }
    },
    {
      field: 'pcDisplay',
      type: 'switch',
      label: 'pc展示'
    }
  ],
  colLayout: 24,
  itemStyle: {}
}
